<template>
    <div class="join-now">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="join-now__content">
                        <Icon icon="ecommerce-badge-icon"/>
                        <div class="join-now__text">
                            <TitleDescription
                                title="Laser Targeting for Free"
                                description="On Crossprom they will share each others products with their audiences and benefit from extra-ordinary high conversions"
                            />
                        </div>
                        <Button 
                            @click.native="$store.commit('TOGGLE_MODAL', ['sign-up', {
                                openedFrom: 'Join Now for Free Top'
                            }])"
                            class="join-now__button" 
                            type="primary"
                        >
                            Join Now for Free
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TitleDescription from '../../../components/Ecommerce/TitleDescription'
import Icon from '../../../components/Theme/Icon'
import Button from '../../../components/Theme/Button'
export default {
    name: 'JoinNow',
    components: {
        Icon,
        TitleDescription,
        Button
    }
}
</script>

<style lang="scss" scoped>
$font: 'Eina SemiBold';
$join_now_top_gap: 80px;
$join_now_bottom_gap: 96px; 
$join_now_text_top_gap: 52px;
$join_now_text_bottom_gap: 36px;
$join_now_top_gap_mob: 72px;
$join_now_bottom_gap_mob: 80px; 
$join_now_top_sm_gap: 56px;
$join_now_bottom_sm_gap: 48px; 
$join_now_text_top_gap_mob: 40px;
$join_now_text_bottom_gap_mob: 32px;
$join_now_text_top_sm_gap: 32px;
$join_now_text_bottom_sm_gap: 24px;
$join_now_text_width: 520px;
$join_now_button_width: 248px;
$join_now_button_fontsize: 16px;
$join_now_button_height: 48px;

$background: #00002D;
.join-now {
    --title-fontsize: 28px;
    --title-lineheight: 32px;
    --description-fontsize: 20px;
    --description-lineheight: 28px;

    --description-font: 'Eina Bold';

    --title-color: #ffffff;
    --description-color: #ffffff;

    @media (max-width: 576px) {
        --title-fontsize: 20px;
        --title-lineheight: 28px;
        --description-fontsize: 16px;
        --description-lineheight: 24px;
    }

    background: $background;
    padding-top: $join_now_top_gap;
    padding-bottom: $join_now_bottom_gap;

    @media (max-width: 768px) {
        padding-top: $join_now_top_gap_mob;
        padding-bottom: $join_now_bottom_gap_mob;
    }
    @media (max-width: 576px) {
        padding-top: $join_now_top_sm_gap;
        padding-bottom: $join_now_bottom_sm_gap;
    }
    &__content {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    &__text {
        width: 100%;
        max-width: $join_now_text_width;
        padding-top: $join_now_text_top_gap;
        padding-bottom: $join_now_text_bottom_gap;
        text-align: center;

        @media (max-width: 768px) {
            padding-top: $join_now_text_top_gap_mob;
            padding-bottom: $join_now_text_bottom_gap_mob;
        }
        @media (max-width: 576px) {
            padding-top: $join_now_text_top_sm_gap;
            padding-bottom: $join_now_text_bottom_sm_gap;
        }
    }
    &__button {
        width: 100%;
        height: $join_now_button_height;
        max-width: $join_now_button_width;
        font-family: $font;
        font-size: $join_now_button_fontsize;
    }
}
</style>>
